import { colors, fonts } from '@grupoboticario/flora-tokens/dist/toqueto/web/ds'

export const toqueto = {
  colors,
  fonts,
}
